export default __webpack_public_path__ + "static/media/popup_conexaoin.b541af0e.png";